import { Box, Image, ModBox, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import { useState } from 'react'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'
import { BoxLayout } from './BoxLayout'

export const AllCardsLayout = ({ data, hideTopText, hideBottomText }: any) => {
  const resPadding = usePadding()
  const { headerSize } = useFontSize()
  const [dimens, setDimens] = useState<any>()

  const viewPortWidth = useWindowDimensions()
  const isMobile = isMobileWidth(viewPortWidth)

  const dots = require('../../assets/svg/oval-dot-pattern.svg')
  const dotsMobile = require('../../assets/svg/dots-mobile.svg')
  return (
    <Box
      ph={resPadding}
      bg={'WHITE'}
      borderTopLeftRadius={isMobile ? 32 : 120}
      borderTopRightRadius={isMobile ? 32 : 120}
      pv={isMobile ? 32 : 120}>
      <Box flexDirection={isMobile ? 'column' : 'row'}>
        <Box f={isMobile ? undefined : 0.5} h={isMobile ? 100 : undefined}>
          <ModBox pr={resPadding * 0.8} pt={isMobile ? 40 : 72} show={isMobile}>
            <Text fontFamily={'jiotype-black'} fontSize={headerSize} lineHeight={isMobile ? 36 : 72} hide={hideTopText}>
              {data.checkListheader}
            </Text>
          </ModBox>
        </Box>
        <Box
          f={isMobile ? undefined : 0.5}
          onLayout={(evt) => setDimens(evt.nativeEvent.layout)}
          mt={isMobile ? 48 : 0}>
          <Box position={'absolute'} bg={'WHITE'} marginLeft={isMobile ? 0 : 40} top={16}>
            <Image
              resizeMode="contain"
              source={isMobile ? dotsMobile : dots}
              width={dimens?.width}
              height={dimens?.height}
            />
          </Box>
          <Spacer size={80} />
          <BoxLayout data={data.checkList} />
        </Box>
      </Box>
    </Box>
  )
}
